import { render, staticRenderFns } from "./RetirePositionPopup.vue?vue&type=template&id=584f7ccf"
import script from "./RetirePositionPopup.vue?vue&type=script&lang=js"
export * from "./RetirePositionPopup.vue?vue&type=script&lang=js"
import style0 from "./RetirePositionPopup.vue?vue&type=style&index=0&id=584f7ccf&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports